import Form from "./Form";
import Utils from "./Utils";

class User {
    public constructor() {
        this.initForms();
    }

    private initForms() {
        $(".login-form, .logout-form").each((i, e) => {
            Form.initForm($(e), () => {
                Utils.setBusy(true);
                window.location.reload();
            });
        });
    }
}

export default User;